import { api } from '@/lib/api'

export function deleteContractor(contractorId: string) {
  return api.delete(`/v1/me/contractors/${contractorId}`)
}
